module.exports = __webpack_public_path__ + "assets/img/69_313_2.40461abe.jpg";